import React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import CardOverflow from "@mui/joy/CardOverflow";
import Divider from "@mui/joy/Divider";
import Typography from "@mui/joy/Typography";
import OrgTag from "./OrgTag";
import SPTag from "./SPTag";
import { useNavigate } from "react-router-dom";

export default function ProjectCard({ project }) {
  const navigate = useNavigate();

  return (
    <>
      <div
        onClick={() => navigate(`/portfolio/${project.id}`)}
        style={{ cursor: "pointer" }}
      >
        <Card
          variant="outlined"
          sx={{
            borderRadius: "24px",
            "&:hover": {
              boxShadow: "md",
              borderColor: "neutral.outlinedHoverBorder",
            },
          }}
        >
          <CardOverflow>
            <AspectRatio ratio="2">
              <img src={project.image} alt={project.title} />
            </AspectRatio>
            <div
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                display: "flex",
                gap: "8px",
              }}
            >
              {project.orgs && (
                <OrgTag
                  label={project.orgs[0].name}
                  abvr={project.orgs[0].abvr}
                  src={project.orgs[0].logo}
                  color={project.orgs[0].color}
                />
              )}
            </div>
          </CardOverflow>
          <CardContent>
            <Typography level="title-md">{project.title}</Typography>
            <Typography
              level="body-sm"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {project.description}
            </Typography>
          </CardContent>
          <Divider orientation="horizontal" inset="none" />
          <CardContent>
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              {project.skills &&
                project.skills.map((skill, index) => (
                  <SPTag
                    key={index}
                    label={skill}
                    color="#1746A0"
                    size="small"
                  />
                ))}
              {project.programmingLanguages &&
                project.programmingLanguages.map((progLang, index) => (
                  <SPTag
                    key={index}
                    label={progLang}
                    color="#219C74"
                    size="small"
                  />
                ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
